
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class AppField extends Vue {
  private inputValue: string | number | null = null;
  private dirty = false;
  private valid = false;
  private uid: string | undefined = undefined;

  @Prop({ required: false })
  private label!: string;

  @Prop({ default: "text", required: false })
  private type!: string;

  @Prop({ default: false, required: false })
  private required!: boolean;

  @Prop({ required: true, type: [String, Number] })
  private value!: string | number | null;

  @Prop({ default: false, required: false })
  private disabled!: boolean;

  @Prop({ default: "on", required: false })
  private autocomplete!: string;

  @Prop({ default: "on", required: false })
  private autocapitalize!: string;

  @Prop({ default: "on", required: false })
  private autocorrect!: string;

  @Prop({ default: "on", required: false })
  private spellcheck!: string;

  @Prop({ required: false })
  private placeholder!: string;

  @Prop({ default: true })
  private showLabel!: boolean;

  @Prop({ default: "" })
  private errorMessage!: string;

  @Prop({ default: 5 })
  private rows!: number;

  @Prop({ required: false })
  private description!: string;

  @Prop({ default: 1 })
  private span!: number;

  @Prop({ required: false })
  private minlength!: number;

  @Prop({ required: false })
  private maxlength!: number;

  @Prop({ required: false })
  private showHelpText!: boolean;

  @Prop({ required: false })
  private suffix?: string;

  get helpText() {
    const { minlength, maxlength, required, showHelpText } = this;

    if (!showHelpText) {
      return "";
    }

    if (!required) {
      return "Optional";
    }

    if (minlength && maxlength) {
      return `${minlength}-${maxlength} characters`;
    }

    if (maxlength) {
      return `Maximum ${maxlength} characters`;
    }

    if (minlength) {
      return `Minimum ${minlength} characters`;
    }

    return "";
  }

  get empty(): boolean {
    return !String(this.inputValue).length;
  }

  get inputID(): string {
    return `${this.uid}__Input`;
  }

  private change(ev: Event) {
    const value = (ev.target as HTMLInputElement).value;
    this.$emit("input", value);
  }

  @Watch("value", { immediate: true })
  private onValueChange(newValue: any) {
    this.inputValue = newValue;
    this.checkValidity();
  }

  private checkValidity() {
    this.valid = this.getValidity();
  }

  private getValidity() {
    if (this.$refs.input) {
      return (this.$refs.input as HTMLInputElement).validity.valid;
    }
    return false;
  }

  private blur() {
    this.dirty = true;
  }

  private createUID() {
    return Math.random().toString(36).substr(2);
  }

  private created() {
    this.uid = this.createUID();
  }
}
